import {Component, OnInit} from '@angular/core';
import {HupSubscriptionsService} from "../../../data/services/hup-subscriptions.service";
import {BaseDataService} from "../../../core/services/base-data.service";
import {BaseData} from "../../../data/models/base-data.model";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslationService} from "../../../core/services/translation.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SnackbarService} from "../../../core/services/snackbar.service";
import {NavigationCommand, NavigationService} from "../../../data/services/navigation.service";
import {ConfigService} from '../../../core/services/config.service';
import {DateAdapter} from '@angular/material/core';
import {DatePipe} from "@angular/common";
import {SubscriptionTerminationType} from "../../../data/models/subscription-termination-type.model";

@Component({
  selector: 'app-hup-subscription-terminate',
  templateUrl: './hup-subscription-terminate.component.html',
  styleUrls: ['./hup-subscription-terminate.component.scss']
})
export class HupSubscriptionTerminateComponent implements OnInit {

  terminationTypes: BaseData[];
  subId: number;
  terminationForm: FormGroup;
  minDate: Date = new Date();
  isLoading: boolean = false;
  showBackToOverviewButton: boolean;

  subscriptionHasCommitment: boolean = false;
  showDefaultTerminationWarning: boolean = false;
  terminationWarning: string = '';

  constructor(
    private hupSubscriptionService: HupSubscriptionsService,
    private baseData: BaseDataService,
    private route: ActivatedRoute,
    public translationService: TranslationService,
    private formBuilder: FormBuilder,
    private snackBar: SnackbarService,
    private navigationService: NavigationService,
    private configService: ConfigService,
    private dateAdapter: DateAdapter<Date>,
    private datePipe: DatePipe
) {
  this.dateAdapter.getFirstDayOfWeek = () => 1;
    this.route.paramMap.subscribe((params) => {
      this.subId = +params.get('subId');

      this.terminationForm = this.formBuilder.group({
        subId: [this.subId, Validators.required],
        reason: ['', Validators.required],
        terminationDate: [this.minDate, Validators.required]
      });

      this.terminationForm.get('reason').valueChanges.subscribe(value => {
        this.hupSubscriptionService.getTerminationDateOfSubscription(this.subId, value.key).subscribe(dates => {
         this.handleDates(dates);
        });
      });
    });
  }

  ngOnInit(): void {
    this.terminationTypes = this.baseData.getBaseData('terminationtypes');
    this.terminationTypes.sort((t1, t2) => t1.sortKey > t2.sortKey ? 1 : -1);

    this.configService.loadConfig('show.backToOverView.button').subscribe(config => {
      if (config && config.value) {
        this.showBackToOverviewButton = (config.value === '1');
      }
    });

    this.configService.loadConfig('subscription.showTerminationWarning').subscribe(config => {
      if (config && config.value) {
        this.showDefaultTerminationWarning = (config.value === '1');
      }
    });
  }

  terminateSubscription() {
    const terminationType: SubscriptionTerminationType = this.terminationForm.get('reason').value;
    const terminationDate: Date = this.terminationForm.get('terminationDate').value;
    this.isLoading = true;
    this.hupSubscriptionService.terminateSubscription(0, this.subId, terminationType.key, terminationDate).subscribe(
      (result) => {
        this.isLoading = false;
        // auf die Übersicht wandern..
        this.navigationService.navigateTo(NavigationCommand.SUBSCRIPTION).then((navigated) => {
          if (navigated) {
            this.snackBar.openSnackbar(this.translationService.getTranslation("saved"));
          }
        });
      }
    );
  }

  handleDates(dates: any) {
    const chosenDate = this.terminationForm.get('terminationDate').value;
    const minTerminationDate = new Date(dates.minTerminationDate);
    const defaultTerminationDate = new Date(dates.defaultTerminationDate);
    if ( chosenDate < defaultTerminationDate ) {
      this.terminationForm.get('terminationDate').setValue(defaultTerminationDate);
    } else if (chosenDate < minTerminationDate) {
      this.terminationForm.get('terminationDate').setValue(minTerminationDate);
    }
    this.minDate = minTerminationDate;

    // Nochmal sicherstellen, dass die Verpflichtung (Commitment) im Spiel ist.
    this.subscriptionHasCommitment = dates.specialConditions === true;

    if (this.subscriptionHasCommitment && this.showDefaultTerminationWarning) {
      const terminationWarningText = this.translationService.getTranslation('subscription.terminationWarning');
      if (terminationWarningText !== '') {
        this.terminationWarning = terminationWarningText.replace('%s', this.datePipe.transform(defaultTerminationDate));
      }
    }
  }

  backToOverview(): void {
    this.navigationService.navigateTo(NavigationCommand.SUBSCRIPTION, null, true);
  }

  printForm(): void {
    console.log(this.terminationForm);
  }
}
